module.exports = __webpack_public_path__ + "files/ddc9d70e13918a7498c927651e3399cc.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activities-2.png
// module id = 520
// module chunks = 76